import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "course-content"
};
import { demoCourseDetail } from '@/api/index-bei-discuss';

/* 工具 */
import { ref, reactive, nextTick, onMounted } from 'vue';
import ELEMENT_COMPONENT_MAP from './Element/const.js';

/* 变量 */

export default {
  __name: 'CourseDemo',
  props: {
    courseId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['loaded', 'noData'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* api */
    var emit = __emit;
    var props = __props;
    var state = reactive({
      pages: [] // 学程每页数据
    });
    var courseRef = ref(null);

    /* 事件 */
    // 获取组件名
    var getComponent = function getComponent(type) {
      return ELEMENT_COMPONENT_MAP[type];
    };
    // 获取组件样式信息
    var getShapeStyle = function getShapeStyle(element) {
      var shapeCssUnits = ['width', 'height', 'x', 'y', 'r', 'layer'];
      var result = {};
      shapeCssUnits.forEach(function (unit) {
        switch (unit) {
          case 'r':
            result.transform = "rotate(".concat(element[unit], "deg)");
            break;
          case 'x':
            result.left = "".concat(element[unit], "px");
            break;
          case 'y':
            result.top = "".concat(element[unit], "px");
            break;
          case 'layer':
            result['z-index'] = element[unit];
            break;
          default:
            result[unit] = "".concat(element[unit], "px");
            break;
        }
      });
      return result;
    };
    var shapeStyle = function shapeStyle(item) {
      var style = getShapeStyle(item.elementContent);
      if (item.elementType === 'exercise') {
        Object.assign(style, {
          height: 'auto'
        });
      }
      return style;
    };
    var getDetail = function getDetail() {
      demoCourseDetail(props.courseId).then(function (res) {
        if (res.data.code === 0) {
          if (res.data.data) {
            var _res$data;
            state.pages = ((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.data) === null || _res$data === void 0 ? void 0 : _res$data.canvases) || [];
            nextTick(function () {
              var _courseRef$value = courseRef.value,
                clientWidth = _courseRef$value.clientWidth,
                clientHeight = _courseRef$value.clientHeight;
              var scaleH = clientHeight * 0.683;
              courseRef.value.style.height = scaleH + 'px';
              emit('loaded', clientWidth, scaleH);
            });
          } else {
            emit('noData');
          }
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getDetail();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "courseRef",
        ref: courseRef,
        class: "course-demo"
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.pages, function (page) {
        return _openBlock(), _createElementBlock("div", {
          class: "page-item",
          key: page.id,
          style: _normalizeStyle({
            height: "".concat(page.height, "px")
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.elements, function (item) {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "ele-item",
            style: _normalizeStyle(shapeStyle(item))
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(item.elementType)), {
            edit: false,
            element: item,
            "element-content": item.elementContent,
            "is-demo": ""
          }, null, 8, ["element", "element-content"]))], 4);
        }), 128))], 4);
      }), 128))])], 512);
    };
  }
};